module.exports = __webpack_public_path__ + "img/8a554.d0740d8f.svg";